var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Home',{attrs:{"aprInitial":_vm.stringToNumber(_vm.apr),"downPaymentInitial":_vm.stringToNumber(_vm.price) * 20 / 100,"downPaymentPercentInitial":20,"priceInitial":_vm.stringToNumber(_vm.price),"termInitial":30}})}
var staticRenderFns = []

export { render, staticRenderFns }